import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const Dropzone = ({ selectedFile, setSelectedFile }) => {
    const [errorMessage, setErrorMessage] = useState("");

    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        if (fileRejections.length > 0) {
            const rejection = fileRejections[0];
            const error = rejection.errors[0];

            let message = "File upload failed. Please check the file requirements.";
            if (error.code === "file-too-large") {
                message = "File size must be under 5MB.";
            } else if (error.code === "file-invalid-type") {
                message = "File extension must be .xls or .xlsx.";
            } else if (error.code === "too-many-files") {
                message = "Only 1 file is allowed.";
            }

            setErrorMessage(message);
            setSelectedFile(null);
            return;
        }

        if (acceptedFiles.length > 0) {
            setSelectedFile(acceptedFiles[0]);
            setErrorMessage("");
        }
    }, [setSelectedFile]);

    const {
        getRootProps,
        getInputProps,
        isDragAccept,
        isDragActive,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: {
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
        },
        maxSize: 5 * 1024 * 1024,
        maxFiles: 1,
        noKeyboard: true,
    });

    const handleRemoveFile = () => {
        setSelectedFile(null);
    };

    return (
        <section>
            {!selectedFile ? (
                <div
                    {...getRootProps({
                        className: `dropzone ${isDragReject ? "border-red-500" : "border-[#E2E2E2]"} border rounded-md h-[151px] w-full flex flex-col items-center justify-center text-center cursor-pointer`,
                    })}
                >
                    <input {...getInputProps()} />
                    {isDragReject ? (
                        <img className="w-[50px] h-[50px]" src={process.env.REACT_APP_ASSETS_IMAGE + "upload-error.png"} alt="Error" />
                    ) : (
                        <img className="w-[50px] h-[50px]" src={process.env.REACT_APP_ASSETS_IMAGE + "upload.svg"} alt="Upload" />
                    )}
                    {isDragAccept && <p className="text-green-primary font-bold">File accepted</p>}
                    {isDragReject && <p className="text-red-500">File not accepted</p>}
                    {isDragReject && errorMessage && <p className="text-sm text-red-500">{errorMessage}</p>}
                    {!isDragActive && !isDragReject && (
                        <>
                            <p>
                                <span className="font-bold text-green-primary underline cursor-pointer">Click to upload</span> or drag and drop
                            </p>
                            <p className="text-sm text-gray-500">File must be .xls or .xlsx and under 5MB (only 1 file allowed)</p>
                        </>
                    )}
                </div>
            ) : (
                <div className="flex items-center justify-between bg-white px-4 py-4 rounded-md">
                    <div className="flex gap-2 items-center">
                        <img className="w-[25px] h-[25px]" src={process.env.REACT_APP_ASSETS_IMAGE + "excel-icon.svg"} alt="Excel" />
                        <p className="font-medium">
                            {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
                        </p>
                    </div>
                    <button type="button" onClick={handleRemoveFile} className="text-green-primary font-bold">
                        X
                    </button>
                </div>
            )}
        </section>
    );
};

export default Dropzone;